// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__FU66X","name":"Header_name__3T2kk","birthday":"Header_birthday__3UnUw","skeleton":"Header_skeleton__3JVM6"};